import { render, staticRenderFns } from "./AppSendMessage.vue?vue&type=template&id=dcf051a0&scoped=true"
import script from "./AppSendMessage.vue?vue&type=script&lang=ts"
export * from "./AppSendMessage.vue?vue&type=script&lang=ts"
import style0 from "./AppSendMessage.vue?vue&type=style&index=0&id=dcf051a0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf051a0",
  null
  
)

export default component.exports